<template>
    <Modal
        @close="$emit('close')">
        <template slot="header">
            {{ siteContent.createNewPost }}
        </template>
        <template slot="body">
            <div v-if="!preview">
                <input class="fileUploadOriginal"
                    accept="image/jpeg"
                    type="file"
                    name="file"
                    id="file"
                    tabindex="-1"
                    @change="uploadFile"/>
                <label class="fileUpload detailInputs"
                    for="file"
                    tabindex="0">
                    <Icon class="addFileIcon"
                        icon="add_photo_alternate"/>
                    {{ siteContent.chooseFile }}
                </label>
                <p class="fileLimitCaption">
                    {{ siteContent.fileSizeLimit }}: 0.3 MB<br/>
                    {{ siteContent.recommendedResolution }}: 1440px x 560px
                </p>
            </div>
            <div v-else class="preview">
                <img :src="preview" class="previewImage"/>
                <Button class="removeButton"
                    appearance="secondary"
                    prefixIcon="delete"
                    size="small"
                    @click="removePreview">
                    {{ siteContent.deleteImage }}
                </Button>
            </div>
            <TextField class="field slug"
                id="slug"
                v-model="slug"
                label="Slug"
                size="large"/>
            <TextField class="field"
                id="title"
                v-model="title.en"
                :label="siteContent.title"
                size="large"/>
            <TextField class="field"
                id="summary"
                v-model="summary.en"
                :label="siteContent.summary"
                size="medium"
                type="textarea">
            </TextField>
            <div class="disclaimer">
                <Heading
                    :h="2"
                    size="m">
                    {{ siteContent.writeYourPostInNextStep }}
                </Heading>
            </div>
        </template>
        <template class="uploadButton"
            slot="footer">
            <Button
                prefixIcon="file_upload"
                @click="createPost">
                {{ siteContent.upload }}
            </Button>
        </template>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'NewPostModal',
        data() {
            return {
                title: {
                    en: '',
                    hu: ''
                },
                cover: '',
                categories: [],
                summary: {
                    en: '',
                    hu: ''
                },
                visibility: false,
                content: '',
                slug: '',
                preview: '',
                delta: {
                    en: [],
                    hu: []
                }
            }
        },
        methods: {
            ...mapActions('blog',['createBlogPost','uploadFileToStore']),

            async uploadFile(e) {
                var files = e.target.files || e.dataTransfer.files
                var fileSize = e.target.files[0].size / 1024 / 1024 // size in MB
                if (fileSize > 0.3) {
                    this.$toasted.show(this.siteContent.keepFilesUnderLimit)
                    this.removePreview(e)
                    return
                } else if (!files.length) {
                    return
                } else {
                    await this.createPreview(files[0])
                    var currentTime = new Date().getTime()
                    var file = files[0]
                    var filePath = 'users/' + this.auth.id + '/posts/' + currentTime.toString() + '/' + file.name.replace(/\.[^/.]+$/, "")  + '.jpg'
                    this.payload = { 
                        file: file,
                        filePath: filePath
                    }
                }
            },

            async createPost() {
                try {
                    var cover = await this.uploadFileToStore(this.payload)
                    const post = {
                        slug: this.slug,
                        title: this.title,
                        summary: this.summary,
                        cover: cover,
                        categories: [],
                        author: this.auth.id,
                        uploadTime: new Date(),
                        visibility: this.visibility
                    }

                    const deltaEn = {
                        deltaEn: this.delta.en
                    }

                    const deltaHu = {
                        deltaHu: this.delta.hu
                    }

                    var slugFormat = /^[a-z0-9-]+$/

                    if(slugFormat.test(this.slug) === false || !this.slug) {
                        this.$toasted.show(this.siteContent.slugError)
                    } else {
                        var result = await this.createBlogPost({ post, deltaEn, deltaHu })
                    }

                    if(result) {
                        this.$toasted.show(this.siteContent.entryUploadSuccess)
                        this.$emit('close')
                        this.$router.push({ path: '/post/' + this.slug, query: { enableEdit: true }})
                    } else {
                        this.$toasted.show(this.siteContent.entryUploadError)
                    }
                } catch(err) {
                    console.log(err)
                }
            },

            createPreview(file) {
                var preview = new Image()
                var reader = new FileReader()
                var vm = this

                reader.onload = (e) => {
                    vm.preview = e.target.result
                }

                reader.readAsDataURL(file)
            },
                
            removePreview(e) {
                this.preview = ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .field {
        margin-bottom: 1.5rem;
    }

    .fileUploadOriginal {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .fileUpload {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 8rem;
        border-radius: 0.5rem;
        transition: $transition-eio-20;
        background: var(--color-grey-100);
        cursor: pointer;

        &:hover {
            background: var(--color-grey-200);
        }

        &:focus {
            outline: 0;
            box-shadow: var(--shadow-focus-s);
        }
    }

    .fileLimitCaption {
        margin: 0.5rem 0 2rem 0;
        font-size: 1rem;
        color: var(--color-grey-600);
    }

    .preview {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1.5rem;
    }

    .previewImage {
        width: 100%;
        height: 25rem;
        border-radius: 0.75rem;
        object-fit: cover;
        display: block;
    }

    .removeButton {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .addFileIcon {
        margin-right: 0.5rem;
        font-size: 2rem;
    }

    .disclaimer {
        display: flex;
        justify-content: center;
        width: 100%;
        text-align: center;
        padding-top: 2rem;
        color: var(--color-grey-400);
    }

    .uploadButtonIcon {
        align-self: center;
        margin: 0 0.75rem 0 -0.25rem;
    }
</style>